import React from 'react'
import ContentLoader from 'react-content-loader'

const RouteListPlaceholder = () => (
  <ContentLoader height={279} width={400} speed={2} backgroundColor="#E6E6E6" foregroundColor="#CDCDCD">
    <rect x="21" y="12" rx="4" ry="4" width="187" height="10" />
    <rect x="297" y="11" rx="3" ry="3" width="64" height="14" />
    <rect x="21" y="39" rx="3" ry="3" width="66" height="9" />
    <rect x="148" y="106" rx="3" ry="3" width="106" height="22" />
    <rect x="0" y="145" rx="3" ry="3" width="398" height="2" />
    <rect x="307" y="35" rx="3" ry="3" width="50" height="9" />
    <rect x="21" y="60" rx="3" ry="3" width="146" height="9" />
    <rect x="22" y="81" rx="3" ry="3" width="136" height="9" />
    <circle cx="256" cy="117" r="11" />
    <circle cx="148" cy="117" r="11" />
    <rect x="0" y="212" rx="3" ry="3" width="398" height="2" />
    <rect x="21" y="164" rx="4" ry="4" width="217" height="10" />
    <rect x="21" y="185" rx="3" ry="3" width="146" height="9" />
    <rect x="294" y="158" rx="3" ry="3" width="64" height="14" />
    <rect x="302" y="182" rx="3" ry="3" width="50" height="9" />
    <rect x="21" y="225" rx="4" ry="4" width="177" height="10" />
    <rect x="21" y="246" rx="3" ry="3" width="156" height="9" />
    <rect x="298" y="226" rx="3" ry="3" width="64" height="14" />
    <rect x="303" y="248" rx="3" ry="3" width="50" height="9" />
  </ContentLoader>
)

export default RouteListPlaceholder
